import React, { useEffect } from 'react'
import { ApolloProvider } from 'react-apollo'
import { ApolloClient } from 'apollo-client'
import { initializeAngularBroadcastEventListener } from '../../ng/shared'

export function getApolloProviderWrapper<TCache>(
  client: ApolloClient<TCache>,
  rootScope: any
) {
  return function wrapper(WrappedComponent) {
    return function ApolloProviderInjector(props) {
      useEffect(() => {
        return initializeAngularBroadcastEventListener(
          rootScope,
          'org:switch',
          client.resetStore
        )
      }, [])

      return (
        <ApolloProvider client={client}>
          <WrappedComponent {...props} />
        </ApolloProvider>
      )
    }
  }
}
